import {ActionCreator} from '@reduxjs/toolkit';

export enum SliceStatus {
  idle = 'idle',
  pending = 'pending',
  resolved = 'resolved',
  rejected = 'rejected',
}

/**
 * Async thunk action type.
 */
export type AsyncThunkActionTypes<
  T extends {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pending: ActionCreator<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rejected: ActionCreator<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fulfilled: ActionCreator<any>;
  },
> =
  | ReturnType<T['pending']>
  | ReturnType<T['fulfilled']>
  | ReturnType<T['rejected']>;
